import { Component, Input } from '@angular/core';
import { SurveyAndOpinionPollRequestTypeEnum } from '../../../models/surveys-tasks/enums/SurveyAndOpinionPollRequestTypeEnum';

@Component({
  selector: 'app-survey-request-type',
  standalone: false,
  templateUrl: './survey-request-type.component.html'
})
export class SurveyRequestTypeComponent {
  @Input() type!: SurveyAndOpinionPollRequestTypeEnum;
  SurveyRequestType = SurveyAndOpinionPollRequestTypeEnum

}
